import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from '~/common/utils';
import { Errors } from './errors';
import * as css from './input.module.scss';
import { FormElementLabel } from './label';
export const Input = ({ ref, className, value, onChange, required, icon, error, errors, title, children, type, 
// eslint-disable-next-line unused-imports/no-unused-vars
touched, ...props }) => {
    // this is needed to prevent annoying input blurring and re-focusing
    const handleMouseDown = (e) => e.preventDefault();
    const handleChange = (event) => {
        switch (type) {
            case 'text':
            case 'password':
            case 'email':
                return onChange(event.currentTarget.value);
            case 'number': {
                const value = event.currentTarget.valueAsNumber;
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                return onChange(Number.isNaN(value) ? null : value);
            }
        }
    };
    return (_jsxs("label", { className: cx(css.wrapper, (error || errors) && css.error, props.disabled && css.disabled, props.readOnly && css.readOnly, className), children: [_jsx(FormElementLabel, { title: title, required: required }), _jsxs("div", { ref: ref, className: css.innerWrapper, children: [icon && _jsx("div", { onMouseDown: handleMouseDown }), _jsx("input", { ...props, className: css.input, value: value || '', onChange: handleChange }), children && (_jsx("div", { onMouseDown: handleMouseDown, className: css.children, children: children }))] }), errors && _jsx(Errors, { errors: errors })] }));
};
